import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase';

@Injectable({
  providedIn: 'root'
})
export class CanActivateViaAuthService implements CanActivate {

  constructor(
    private router: Router
  ) {}

  canActivate(): Observable<any> {
    let user = firebase.auth().currentUser;
    if(user) {
       return Observable.of(true);
     } else {
       this.router.navigate(['/login']);
       return Observable.of(false);
     }
  }
}

